import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { doSignInWithEmailAndPassword } from '../../../firebase/auth';
import { useAuth } from '../../../contexts/authContext';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import bgImage from '../../../assets/a.jpg';

const Login = () => {
    const { userLoggedIn } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSigningIn, setIsSigningIn] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!isSigningIn) {
            setIsSigningIn(true);
            try {
                await doSignInWithEmailAndPassword(email, password);
                navigate('/home', { state: { message: 'Login successful!', type: 'success' } });
            } catch (error) {
                setErrorMessage(error.message);
                navigate('/home', { state: { message: 'Login failed. Please try again.', type: 'error' } });
            }
            setIsSigningIn(false);
        }
    };

    return (
        <div className="flex min-h-screen">
            {/* Left Section with Image */}
            <div className="w-1/2 h-screen bg-cover bg-center" style={{ backgroundImage: `url(${bgImage})` }}></div>
            
            {/* Right Section with Login Form */}
            <div className="w-1/2 flex justify-center items-center p-6">
                {userLoggedIn && (<Navigate to={'/home'} replace={true} />)}
                <div className="w-96 text-gray-600 space-y-5 p-6 shadow-xl border rounded-xl">
                    <div className="text-center">
                        <h3 className="text-gray-800 text-xl font-semibold sm:text-2xl">Welcome Back</h3>
                    </div>
                    <form onSubmit={onSubmit} className="space-y-5">
                        <div>
                            <label className="text-sm text-gray-600 font-bold">Email</label>
                            <input type="email" autoComplete='email' required value={email} onChange={(e) => { setEmail(e.target.value) }}
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300" />
                        </div>
                        <div>
                            <label className="text-sm text-gray-600 font-bold">Password</label>
                            <input type="password" autoComplete='current-password' required value={password} onChange={(e) => { setPassword(e.target.value) }}
                                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300" />
                        </div>
                        {errorMessage && (<span className='text-red-600 font-bold'>{errorMessage}</span>)}
                        <button type="submit" disabled={isSigningIn} className={`w-full px-4 py-2 text-white font-medium rounded-lg ${isSigningIn ? 'bg-gray-300 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700 hover:shadow-xl transition duration-300'}`}>
                            {isSigningIn ? 'Signing In...' : 'Sign In'}
                        </button>
                    </form>
                </div>
            </div>
            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default Login;
